import { supabase } from '../lib/supabase';

export const wellbeingService = {
  /**
   * Add wellbeing score
   */
  async addWellbeingScore(scoreData) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('wellbeing_scores')?.insert({
          user_id: user?.id,
          score: scoreData?.score,
          mood: scoreData?.mood,
          notes: scoreData?.notes
        })?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('Add wellbeing score error:', error);
      return { data: null, error };
    }
  },

  /**
   * Get user's wellbeing history
   */
  async getWellbeingHistory(limit = 30) {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('wellbeing_scores')?.select('*')?.eq('user_id', user?.id)?.order('recorded_at', { ascending: false })?.limit(limit);

      if (error) throw error;

      // Convert snake_case to camelCase
      const scores = data?.map(score => ({
        id: score?.id,
        score: score?.score,
        mood: score?.mood,
        notes: score?.notes,
        recordedAt: score?.recorded_at
      })) || [];

      return { data: scores, error: null };
    } catch (error) {
      console.error('Get wellbeing history error:', error);
      return { data: [], error };
    }
  },

  /**
   * Get latest wellbeing score
   */
  async getLatestScore() {
    try {
      const { data: { user } } = await supabase?.auth?.getUser();
      if (!user) throw new Error('Not authenticated');

      const { data, error } = await supabase?.from('wellbeing_scores')?.select('*')?.eq('user_id', user?.id)?.order('recorded_at', { ascending: false })?.limit(1)?.single();

      if (error && error?.code !== 'PGRST116') throw error; // Ignore "not found" error

      if (data) {
        return {
          data: {
            score: data?.score,
            mood: data?.mood,
            recordedAt: data?.recorded_at
          },
          error: null
        };
      }

      return { data: null, error: null };
    } catch (error) {
      console.error('Get latest score error:', error);
      return { data: null, error };
    }
  }
};